import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";

import { captainBillingKeys } from "./query-keys";
import { captainBillingUrl } from "./url";
import type { CaptainBillingUsageMonth } from "../types";

import { instance } from "@/lib/axios/instance";

export function useCaptainBillingUsage(clientId: string, months: number) {
  return useQuery<CaptainBillingUsageMonth[], AxiosError>({
    queryKey: captainBillingKeys.usage(clientId, months),
    queryFn: () =>
      instance
        .get<CaptainBillingUsageMonth[]>(captainBillingUrl(clientId, "Usage"), { params: { months } })
        .then((res) => res.data),
    enabled: !!clientId,
    refetchOnMount: true, // Overrides the global false so a `captain-billing:balance-changed` realtime invalidation (api/realtime.ts) refetches on return
  });
}
